import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import AutoFontSizer from "views/components/visualizations/number/AutoFontSizer";
import { ElementDimensions } from "components/common";
import RenderCompletionCallback from "views/components/widgets/RenderCompletionCallback";
const NumberBox = styled(ElementDimensions)`
  height: 100%;
  width: 100%;
  padding-bottom: 10px;
`;
const InvestigationsNumber = ({ data }) => {
  const onRenderComplete = useContext(RenderCompletionCallback);
  useEffect(() => {
    onRenderComplete();
  }, [onRenderComplete]);
  return /* @__PURE__ */ React.createElement(NumberBox, { resizeDelay: 20 }, ({ height, width }) => /* @__PURE__ */ React.createElement(AutoFontSizer, { height, width, center: true }, /* @__PURE__ */ React.createElement("div", null, data.totalResults)));
};
export default InvestigationsNumber;
